<template>
    <div style="background-color: #f2f2f2;height: 100%;" class="careRemind">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            月收费统计
        </div>
        <div style="padding: 20px;">
            <div>
                <Search :searchForm='searchForm' :searchData='searchData' v-on:getList='getList' ref="Search">
                    <template slot="monthrange">
                         <el-date-picker
                            v-model="searchForm.month"
                            :clearable="false"
                            type="month"
                            value-format="yyyy-MM"
                            placeholder="请选择月份">
                        </el-date-picker>
                    </template>
                    <template slot="rightButton">
                         <el-button type="success" icon="el-icon-download" @click="download">导出</el-button>
                    </template>
                </Search>
                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table ref="table" v-loading="tableload" :data="tableData" :height="th" border style="width: 100%;"  :summary-method="getSummaries"
    show-summary>

                        <el-table-column prop="monthString" label="月份" min-width="100"></el-table-column>
                        <el-table-column prop="name" label="老人姓名" min-width="100"></el-table-column>
                        <el-table-column prop="balance" label="余额"  min-width="100"></el-table-column>
                        <el-table-column prop="consumeMoney" label="消费总金额"  min-width="100"></el-table-column>
                        <el-table-column prop="rechargeMoney" label="本月充值"  min-width="100"></el-table-column>
                        <el-table-column prop="deposit" label="预交金"  min-width="80"></el-table-column>
                        <el-table-column prop="imprest" label="备用金"  min-width="80"></el-table-column>
                        <el-table-column prop="checkinTime" :formatter="formatterTime" label="入住日期"  min-width="180"></el-table-column>
                        <el-table-column prop="checkinTrueDays" label="入住天数"  min-width="100"></el-table-column>
                        <el-table-column prop="leaveDays" label="请假天数"  min-width="100"></el-table-column>
                        <el-table-column prop="leaveReturnMoney" label="请假退还金额"  min-width="120"></el-table-column>
                        <el-table-column prop="couponAllMoney" label="优惠券总金额"  min-width="120"></el-table-column>
                        <el-table-column align='center' label="房间床位收费">
                            <el-table-column prop="roomTypeName" label="房间类型"  min-width="100"></el-table-column>
                            <el-table-column prop="roomTypePrice" label="标准价"  min-width="80"></el-table-column>
                            <el-table-column prop="roomTypePriceDiscount" label="折后价"  min-width="80"></el-table-column>
                            <el-table-column prop="roomTypePriceTure" label="实际收取"  min-width="100"></el-table-column>
                        </el-table-column>
                        <el-table-column align='center' label="护理收费">
                            <el-table-column prop="nursingLevelName" label="护理级别"  min-width="100"></el-table-column>
                            <el-table-column prop="nursingLevelPrice" label="标准价"  min-width="80"></el-table-column>
                            <el-table-column prop="nursingLevelPriceDiscount" label="折后价"  min-width="80"></el-table-column>
                            <el-table-column prop="nursingLevelPriceTure" label="实际收取"  min-width="100"></el-table-column>
                        </el-table-column>
                        <el-table-column align='center' :label="item.name" v-for="(item,i) in institutionFeeList" :key="i">
                            <el-table-column label="标准价"  min-width="80">
                                <template slot-scope="scope">
                                    <span>{{getFeeData(1,scope.row.censusAutomatchElderlyConsumeRecordMonthFees,item.institutionFeeCode)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="折后价"  min-width="80">
                                <template slot-scope="scope">
                                    <span>{{getFeeData(2,scope.row.censusAutomatchElderlyConsumeRecordMonthFees,item.institutionFeeCode)}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="实际收取" min-width="100">
                                <template slot-scope="scope">
                                    <span>{{getFeeData(3,scope.row.censusAutomatchElderlyConsumeRecordMonthFees,item.institutionFeeCode)}}</span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column align='center' label="手动扣费" min-width="100">
                            <el-table-column :label="item.name" v-for="(item,i) in deductionItemList" :key="i">
                                <template slot-scope="scope">
                                    <span>{{getHandData(scope.row.censusAutomatchElderlyConsumeRecordMonthItems,item.deductionItemCode)}}</span>
                                </template>
                            </el-table-column>
                        </el-table-column>
                        <el-table-column prop="fixedFee" label="固定费用"  min-width="100"></el-table-column>
                        <el-table-column prop="createTime" :formatter="formatterTime" label="创建日期"  min-width="180"></el-table-column>
                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <el-dialog title="自选配项目详情" :visible.sync="dialogFeeChange" width="650px">
            <el-table :data="feeTable" border show-summary style="width: 100%">
                <el-table-column property="institutionFeeName" label="收费项目"></el-table-column>
                <el-table-column property="institutionFeePrice" :formatter="formatterTime1" label="标准价"></el-table-column>
                <el-table-column property="institutionFeePriceDiscount" sortable label="折后价"></el-table-column>
                <el-table-column property="institutionFeePriceTure" label="实际收取价"></el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog title="手动扣费详情" :visible.sync="dialogHandChange" width="650px">
            <el-table :data="handTable" border show-summary style="width: 100%">
                <el-table-column property="deductionItemName" label="扣费项目"></el-table-column>
                <el-table-column property="deductionItemPrice" label="扣费金额"></el-table-column>
            </el-table>
        </el-dialog>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import {getStaffCode,getToken} from "@/utils/auth";
    import Search from "@/components/Search";

    export default {
        name: "Role",
        data(){
            return{
                tableload:false,
                dialogFeeChange:false,
                dialogHandChange:false,
                selectInfo:'',
                tableData:null,
                totalItems: 0,
                pageSize:20,
                roomCodeList:[],
                feeTable:[],
                handTable:[],
                currentPage:1,
                roomCode:'00000000-0000-0000-0000-000000000000',
                number:'',
                status:-1,
                th:0,searchData:[],
                searchForm:{
                    month: '',
                    name: '',
                    idCard: '',
                },
                options:[],
                institutionFeeList:[],
                deductionItemList:[],
                listSonInstitutionList:[],
                sonStaffCode:'',
                summation:[]
                // oldInsCode:'',
            }
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },
        components: {
            Search
        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
            searchForm:{
                handler(val){
                    this.listSonInstitutionList.forEach(element => {
                        if(element.sonInstitutionCode==val.institutionCode){
                            this.sonStaffCode=element.staffCode
                        }
                    });
                },
                deep: true // 是否监听对象内部属性的变化
            },
        },
        methods:{
            init(){
                let staffDTO=JSON.parse(getToken())
                this.listSonInstitutionList=staffDTO.institutionDTO.listSonInstitutionRelDTO
                this.searchData=[
                    {span:12,name:'姓名',width:210,value:'name',type:'input'},
                    {span:12,name:'身份证号',width:210,value:'idCard',type:'input'},
                    {span:12,name:'机构',width:210,value:'institutionCode',type:'select',options:staffDTO.institutionDTO.listSonInstitutionRelDTO,props:{label:'sonInstitutionName',value:'sonInstitutionCode'}},
                    {span:24,name:'月份',width:210,value:'monthrange',type:'slot'},
                ]
                var nowDate=new Date();
                this.searchForm={
                    institutionCode:this.listSonInstitutionList[0].sonInstitutionCode,
                    month:timefilters(nowDate).slice(0,7),
                    name:'',
                    idCard:''
                }
                this.tableload=true
                this.oldInsCode=this.listSonInstitutionList[0].sonInstitutionCode
                this.sonStaffCode=this.listSonInstitutionList[0].staffCode
                
            },
            getSummaries(){
                return this.summation;
            },
            newValue() {return this.searchForm.institutionCode},
            getFeeData(type,list,code){
                let data=null;
                list.forEach(element => {
                    if(code==element.institutionFeeCode){
                        data=element;
                    }
                });
                if(!data){
                    return 0;
                }
                let feeData=null;
                switch(type){
                    case 1:
                        feeData=data.institutionFeePrice
                        break;
                    case 2:
                        feeData=data.institutionFeePriceDiscount
                        break;
                    case 3:
                        feeData=data.institutionFeePriceTure
                        break;
                }
                return feeData;
            },
            download(){
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.$axios.get(this.$institutionUrl + 'CensusAutomatchElderlyConsumeRecordMonth/ExportElderlyAll', {
                responseType: 'blob',
                params: {
                    timeStr: timeStr,
                    sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                    staffCode: getStaffCode(),
                    month:this.searchForm.month,
                    name:this.searchForm.name,
                    idCard:this.searchForm.idCard,
                    institutionCode:this.searchForm.institutionCode
                }
                }).then(
                    (response) => {
                    loading.close();
                    // this.goodsClassDataShow = !this.goodsClassDataShow;
                    if (response.data.type === 'application/json') {
                        this.$message({type: 'info', message: '暂无数据'});
                    } else {
                        let fileName = '月收费统计表.xlsx';
                        this.file(response, fileName);
                    }

                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            getHandData(list,code){
                let price=0;
                list.forEach(element => {
                    if(code==element.deductionItemCode){
                        price=element.deductionItemPrice;
                    }
                });
                return price;
            },
            getList(isSearch) {
                if(isSearch)this.currentPage=1
                var _this=this
                this.tableload=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),
                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,
                }
                Object.assign(data,this.searchForm)
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CensusAutomatchElderlyConsumeRecordMonth/PageAll",
                    data: data
                }).then( (response)=> {
                    this.tableload = false;
                    if(response.data.error == 0){
                         this.institutionFeeList = response.data.data.institutionFee;
                        this.deductionItemList = response.data.data.deductionItem;
                        this.$nextTick(()=>{
                            this.$refs.table.doLayout()
                        })
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                        this.summation = response.data.data.summation;
                        // this.$nextTick(()=>{
                        //     this.$refs.table.doLayout()
                        // })
                    }else if(response.data.error == 1){
                        this.$message({type: 'info', message: response.data.message});
                    }
                }).catch(function (error) {
                    _this.tableload = false;
                    console.log(error);
                });
            },
            formatterTime(row, column, cellValue) {
                return cellValue?cellValue.replace('T',' ').slice(0,19):null
            },
            openFee(data){
                this.dialogFeeChange=true;
                this.feeTable=data.censusAutomatchElderlyConsumeRecordMonthFees
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            openHand(data){
                this.dialogHandChange=true;
                this.handTable=data.censusAutomatchElderlyConsumeRecordMonthItems
            }
        }
    }
</script>

<style lang="scss" scoped>
    // .BerthPage{
    //     .el-button{
    //         transform: translate(-1px,0);
    //     }
    // }
    .careRemind /deep/ .el-table__body tr.current-row>td {
        background: rgb(102, 177, 255);
        color:#fff;
    }
</style>
